import { render, staticRenderFns } from "./otp-modal.vue?vue&type=template&id=39a7160c&scoped=true&"
import script from "./otp-modal.ts?vue&type=script&lang=ts&"
export * from "./otp-modal.ts?vue&type=script&lang=ts&"
import style0 from "./otp-modal.vue?vue&type=style&index=0&id=39a7160c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a7160c",
  null
  
)

export default component.exports